define('dom',['require','dom/animator','dom/toggler','dom/selector','dom/anchorPanel'],function(require)
{
	return {
		animator:    require('dom/animator'),
		toggler:     require('dom/toggler'),
		selector:    require('dom/selector'),
		anchorPanel: require('dom/anchorPanel')
	};
});
